import { CdkVirtualScrollViewport } from '@angular/cdk/scrolling';
import { AfterViewInit, Directive, Input, OnChanges, SimpleChanges, ViewContainerRef } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { DefaultSavedTableSettings, SessionStorageService } from '@core';

import { TableZoomComponent } from './table-zoom.component';

@Directive({ selector: '[avsVirtualTableScrollNormalizer]', standalone: true })
export class VirtualTableScrollNormalizerDirective implements AfterViewInit, OnChanges {
  @Input() tableMinHeight = 0;
  @Input() zoomEnabled = true;
  @Input() changeTrigger!: any;
  @Input() tableId: string | null = null;
  private prevItemsCount!: number;

  constructor(
    private viewport: CdkVirtualScrollViewport,
    private viewContainerRef: ViewContainerRef,
    private sessionStorageService: SessionStorageService,
  ) {
  }

  ngAfterViewInit(): void {
    this.addZoomInterface();
    if (!this.tableId) return;
    const tableSavedData = this.sessionStorageService.getItem(this.tableId);

    if (!tableSavedData && this.tableId) {
      this.sessionStorageService.setItem(this.tableId, DefaultSavedTableSettings);
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['changeTrigger']) {
      const currentChanges = this.viewport && changes['changeTrigger'].currentValue;

      if (this.viewport) {
        if (currentChanges instanceof MatTableDataSource) {
          if (currentChanges.filteredData.length !== this.prevItemsCount) {
            this.viewport?.scrollToOffset(0, 'auto');
          }
          this.prevItemsCount = currentChanges.filteredData.length;
        } else if (Array.isArray(currentChanges)) {
          if (currentChanges.length !== this.prevItemsCount) {
            this.viewport?.scrollToOffset(0, 'auto');
          }
          this.prevItemsCount = currentChanges.length;
        }
      }
    }
  }

  addZoomInterface() {
    if (this.viewContainerRef && this.zoomEnabled) {
      const componentRef = this.viewContainerRef.createComponent(TableZoomComponent);

      componentRef.setInput('tableId', this.tableId);
      Object.assign(componentRef.instance, this.viewport);
    }
  }
}
